import { Checkbox } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import clsx from 'clsx';
import { FC, useState } from 'react';
import {
  IRuleValidation,
  useAddRuleValidationToRuleMutation,
  useDeleteRuleValidationMutation,
  useRemoveRuleValidationFromRuleMutation,
} from '../../../redux/services/settings';
import { CustomTypography } from '../../custom/CustomTypography';
import { IconWithTooltip } from '../../shared/IconWithTooltip';
import styles from './RuleValidation.module.css';

type TRuleValidationField = {
  rule: IRuleValidation;
  onEdit: () => void;
  checked: boolean;
  fieldName: string;
};

export const RuleValidation: FC<TRuleValidationField> = ({ rule, onEdit, checked, fieldName }) => {
  const [deleteRuleValidation] = useDeleteRuleValidationMutation();
  const [addRuleValidationToRule] = useAddRuleValidationToRuleMutation();
  const [removeRuleValidationFromRule] = useRemoveRuleValidationFromRuleMutation();
  const [isCheck, setIsCheck] = useState<boolean>(checked);

  const handleDelete = async () => {
    await deleteRuleValidation(rule.id);
  };

  const handleCheck = async () => {
    try {
      if (!isCheck) {
        await addRuleValidationToRule({ field_name: fieldName, id: rule.id }).unwrap();
      } else {
        await removeRuleValidationFromRule({ field_name: fieldName, id: rule.id }).unwrap();
      }

      setIsCheck(!isCheck);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ListItem
      data-id="rule-validation-item"
      className={clsx(styles.item, rule.active ? '' : styles.inactive)}
    >
      <div className={styles.content}>
        <div className={styles.header}>
          <Checkbox checked={isCheck} onClick={handleCheck} disabled={!rule.active} />
          <CustomTypography className="text-14">{rule.title}</CustomTypography>
        </div>
        <div className={styles.buttons}>
          <IconWithTooltip iconType="edit" onClick={onEdit} />
          <IconWithTooltip iconType="delete" onClick={handleDelete} placement="bottom-end" />
        </div>
      </div>
    </ListItem>
  );
};
